import { isValidElement } from 'react';
import { Chip, ChipProps } from '@mui/material';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';

interface IProps extends ChipProps {
  styles?: string;
  dataId?: string;
}

export const ChipBadge = ({ dataId, label, ...props }: IProps) => {
  const labelHasId =
    isValidElement(label) &&
    Boolean((label.props as { 'data-id'?: string })['data-id']);
  const renderedLabel =
    dataId && !labelHasId ? <span data-id={dataId}>{label}</span> : label;

  return (
    <Chip
      {...props}
      label={renderedLabel}
      sx={{
        width: 'max-content',
        padding: {
          xs: `${pxToRem(6)} ${pxToRem(10)}`,
          md: `${pxTovW(6)} ${pxTovW(10)}`,
        },
        // width: { xs: pxToRem(45), md: pxTovW(55) },
        fontSize: 'inherit',
        ...props.sx,
      }}
    />
  );
};
